const productData = [
  {
    image: 'none',
    brand: 'Colmar',
    name: 'MD29993S_1BC_455',
    category: 'MD',
    subCategory: 'DONNA',
  },
  {
    image: 'none',
    brand: 'Colmar',
    name: 'MD29993S_1BC_455',
    category: 'MD',
    subCategory: 'DONNA',
  },
  {
    image: 'none',
    brand: 'Colmar',
    name: 'MD29993S_1BC_455',
    category: 'MD',
    subCategory: 'DONNA',
  },
  {
    image: 'none',
    brand: 'Colmar',
    name: 'MD29993S_1BC_455',
    category: 'MD',
    subCategory: 'DONNA',
  },
  {
    image: 'none',
    brand: 'Colmar',
    name: 'MD29993S_1BC_455',
    category: 'MD',
    subCategory: 'DONNA',
  },
  {
    image: 'none',
    brand: 'Colmar',
    name: 'MD29993S_1BC_455',
    category: 'MD',
    subCategory: 'DONNA',
  },
  {
    image: 'none',
    brand: 'Colmar',
    name: 'MD29993S_1BC_455',
    category: 'MD',
    subCategory: 'DONNA',
  },
];

export { productData };
